<script>
  import { Phone, Video } from 'lucide-svelte';
  import { formatDuration } from '$lib//utils/datetime.js';

  export let call = null;
  export let isMine = false;

  $: isMissed = call?.status === 'missed';
  $: isVideo = call?.callType === 'video';
  $: label = getCallLabel(call);

  function getCallLabel(value) {
    if (!value) return '';
    if (value.status === 'missed') return 'Cuộc gọi nhỡ';
    if (value.callType === 'video') return `Cuộc gọi video · ${formatDuration(value.duration)}`;
    return `Cuộc gọi audio · ${formatDuration(value.duration)}`;
  }
</script>

{#if call}
  <div class:call-message--mine={isMine} class:call-message--missed={isMissed} class="call-message">
    <span class="call-message__icon" aria-hidden="true">
      {#if isVideo}
        <Video size={16} strokeWidth={2.2} />
      {:else}
        <Phone size={16} strokeWidth={2.2} />
      {/if}
    </span>
    <span>{label}</span>
  </div>
{/if}

<style>
  .call-message {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: #1f2937;
    font-size: 0.86rem;
    line-height: 1.35;
  }

  .call-message--mine {
    color: #374151;
  }

  .call-message--missed {
    color: #b42318;
  }

  .call-message__icon {
    display: grid;
    place-items: center;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 999px;
    color: currentColor;
    background: rgba(255, 255, 255, 0.42);
  }
</style>
